import { render, staticRenderFns } from "./AddVendor.vue?vue&type=template&id=a0d7c05a"
import script from "./AddVendor.vue?vue&type=script&lang=ts"
export * from "./AddVendor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports